export default "__VITE_ASSET__DFUNmOfz__"